<template>
  <div>
    <van-nav-bar title="订单列表"
                 left-text="返回"
                 left-arrow>
      <template #right>
        <van-icon name="search"
                  size="18" />
      </template>
    </van-nav-bar>
    <!-- 列表 -->
    <div v-for="(item, index) in allSysBookingList"
         :key="index">
      <div style="margin-top:5px"></div>
      <van-card :desc="item.title +'：'+item.package +'【场次/时间：'+item.trip_start_time+'】'"
                :title="'订单编号：'+item.ota_id ">
        <!-- 场次 -->
        <template #tags>
          <div>姓名：{{item.contact_name}}｜电话：{{item.contact_phone}}</div>

        </template>
        <!-- 人数 -->
        <template #price>
          <div>成人：{{item.adult_num}}</div>
          <div>儿童：{{item.child_num}}</div>
        </template>
        <!-- 按钮 -->
        <template #footer>
          <van-button @click="copyInfor(item.booking_no)"
                      size="mini">复制订单信息</van-button>
          <van-button @click="getVoucher(item)"
                      size="mini">确认单</van-button>
        </template>
      </van-card>
    </div>

  </div>
</template>

<script>
import { List } from 'vant'
import { Cell, CellGroup } from 'vant'
import { NavBar } from 'vant'
import { Icon } from 'vant'
import { Card } from 'vant'
import { Button } from 'vant'
import { Notify } from 'vant'
export default {
  name: 'm_booking_list',
  components: {
    'van-card': Card,
    'van-list': List,
    'van-cell': Cell,
    'van-cell-group': CellGroup,
    'van-nav-bar': NavBar,
    'van-icon': Icon,
    'van-button': Button,
    [Notify.Component.name]: Notify.Component,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pagenum_system: 1,
      pagesize_system: 10,
      waitAccept: 0,
      changeBooking: 0,
      allSysBookingList: [],
      total_system: -1,
      confirmation: '',
    }
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    onLoad() {},
    // 获取 系统订单  及 分页
    getOrderList() {
      this.loading = true
      this.$http
        .get(
          `/booking/list?page_number=${this.pagenum_system}&page_size=${this.pagesize_system}`
        )
        .then((res) => {
          const { data, errmsg, errno } = res.data
          // console.log(res)
          if (errno === '0') {
            this.waitAccept = data.wait_accept
            this.waitAcceptDate = data.wait_accept_near_date
            this.changeBooking = data.change_booking
            this.allSysBookingList = data.booking
            this.total_system = data.item_account
          } else {
            this.$notify.error({
              title: '警告',
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },

    // 检查字符串是否为空
    checkEmpty(str) {
      var res = str
      if (res == '' || res == undefined || res == null) {
        return ''
      } else {
        return res
      }
    },
    // 获取 确认信息
    getConfirmInfor() {
      this.$http
        .get(`/booking/detail?booking_id=${this.dealWithBookingNum}`)
        .then((res) => {
          const { data, errmsg, errno } = res.data
          // console.log(res)
          if (errno == '0') {
            // console.log("进入promise");
            // 订单编号
            let information_id = '订单编号：' + data.about_booking.ota_id + '\n'
            // 出行日期
            let information_date =
              '出行日期：' + data.about_booking.trip_start_date + '\n'
            // 套餐名称
            let information_title =
              '套餐名称：' + data.about_booking.sku_name + '\n'
            // 场次
            let information_time =
              '场次/时间：' +
              this.checkEmpty(data.about_booking.start_time) +
              '\n'

            // 判断 订单信息 是否为空 -》 处理订单信息
            let pick_is_null = this.checkEmpty(
              data.about_booking.additional_info
            )
            let addition_info = ''
            if (pick_is_null) {
              let addition_list = []
              pick_is_null.forEach((item, index) => {
                let i = item.name + '：' + item.value + '\n'
                addition_list.push(i)
              })
              addition_info = addition_list.join('')
            } else {
              addition_info = ''
            }

            // 判断人数是否为空 -》 处理人数
            let information_num = this.checkEmpty(data.about_booking.num)
            let num_list = []
            information_num.forEach((item, index) => {
              let i = item.type + '：' + item.num + '\n'
              num_list.push(i)
            })
            let num_info = num_list.join('')

            // 判断附加项是否为空 -》 处理 附加项
            let select_addition_dict = this.checkEmpty(
              data.about_booking.select_addition_dict
            )
            let select_addition_info = ''
            if (select_addition_dict) {
              let select_addition_list = []
              select_addition_dict.forEach((item, index) => {
                let i = item.addition_name + '：' + item.addition_num + '\n'
                select_addition_list.push(i)
              })
              select_addition_info =
                '------附加项------' + '\n' + select_addition_list.join('')
            } else {
              select_addition_info = ''
            }

            // 联系人
            let information_other =
              '联系人姓名：' +
              data.about_contact.name +
              '\n' +
              '联系电话：' +
              data.about_contact.mobile +
              '\n'

            // // 出行人信息：
            // let information_travellers =
            //   "--------" + "\n" + "出行人信息：" + "\n";
            // data.travellers.forEach((i, index) => {
            //   if (i.traveller_name_en == null) {
            //     information_travellers =
            //       information_travellers + i.traveller_name;
            //   } else {
            //     information_travellers =
            //       information_travellers +
            //       i.traveller_name +
            //       i.traveller_name_en;
            //   }

            //   i.credential.forEach((item, index) => {
            //     if (item.credential != null) {
            //       information_travellers =
            //         information_travellers +
            //         "\n" +
            //         item.credential +
            //         ":" +
            //         item.credentialNum +
            //         "\n";
            //     }
            //   });
            // });

            // 汇总
            let information =
              '您好，您的行程已确认' +
              '\n' +
              '到店后报姓名 、电话即可:' +
              '\n' +
              '\n' +
              information_id +
              information_date +
              information_title +
              information_time +
              num_info +
              information_other +
              addition_info +
              select_addition_info

            // 获取确认单信息
            let a = document.getElementsByClassName('voucher-footer')
            // let confirm_infor = a[0].innerText
            this.confirmation = information
            //
          } else if (errno == '4002') {
            this.$notify({
              title: '警告',
              message: '该订单还未入库，请先入库',
              type: 'warning',
            })
          }
        })
    },
    // 复制订单信息，获取订单信息，放到剪贴板，提示成功
    copyInfor(id) {
      this.dealWithBookingNum = id
      // 修改订单状态，booking_id
      // console.log("改状态");
      this.$http
        .post('/booking/status', {
          status: 'CONFIRM',
          booking_id: this.dealWithBookingNum,
          ota_id: '',
        })
        .then((res) => {
          console.log(res)
        })
      this.copyText()
    },
    // 复制信息
    copyText() {
      this.getFormedBookingInfo()
      this.$copyText(this.information)
        .then((res) => {
          Notify({ type: 'success', message: '该订单信息已复制到剪贴板' })
          this.information = ''
          // console.log("成功");
        })
        .catch((err) => {
          console.log(err)
        })
    },
    copyConfirmation(booking_id) {
      this.dealWithBookingNum = booking_id
      this.getConfirmInfor()
      this.$copyText(this.confirmation)
        .then((res) => {
          this.$message({
            message: '该订单信息已复制到剪贴板',
            type: 'success',
          })
          this.confirmation = ''
          // console.log("成功");
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //
    // 获取 特定格式的 订单的预定信息，用于预定等
    async getFormedBookingInfo() {
      const res = await this.$http.get(
        `/booking/detail?booking_id=${this.dealWithBookingNum}`
      )

      const { data, errmsg, errno } = res.data
      if (errno == '0') {
        // 订单编号
        let information_id = '订单编号：' + data.about_booking.ota_id + '\n'
        // 出行日期
        let information_date =
          '出行日期：' + data.about_booking.trip_start_date + '\n'
        // 套餐名称
        let information_title =
          '套餐名称：' + data.about_booking.sku_name + '\n'
        // 场次
        let information_time =
          '场次/时间：' + this.checkEmpty(data.about_booking.start_time) + '\n'

        // 判断 订单信息 是否为空 -》 处理订单信息
        let pick_is_null = this.checkEmpty(data.about_booking.additional_info)
        let addition_info = ''
        if (pick_is_null) {
          let addition_list = []
          pick_is_null.forEach((item, index) => {
            let i = item.name + '：' + item.value + '\n'
            addition_list.push(i)
          })
          addition_info = addition_list.join('')
        } else {
          addition_info = ''
        }

        // 判断人数是否为空 -》 处理人数
        let information_num = this.checkEmpty(data.about_booking.num)
        let num_list = []
        if (information_num.length > 0) {
          information_num.forEach((item, index) => {
            let i = item.type + '：' + item.num + '\n'
            num_list.push(i)
          })
        }
        let num_info = num_list.join('')

        // 判断附加项是否为空 -》 处理 附加项
        let select_addition_dict = this.checkEmpty(
          data.about_booking.select_addition_dict
        )
        let select_addition_info = ''
        if (select_addition_dict) {
          let select_addition_list = []
          select_addition_dict.forEach((item, index) => {
            let i = item.addition_name + '：' + item.addition_num + '\n'
            select_addition_list.push(i)
          })
          select_addition_info =
            '------附加项------' + '\n' + select_addition_list.join('')
        } else {
          select_addition_info = ''
        }

        // 联系人
        let information_other =
          '联系人姓名：' +
          data.about_contact.name +
          '\n' +
          '联系电话：' +
          data.about_contact.mobile +
          '\n'

        // 出行人信息：
        let information_travellers = '--------' + '\n' + '出行人信息：' + '\n'
        data.travellers.forEach((i, index) => {
          if (i.traveller_name_en == null) {
            information_travellers = information_travellers + i.traveller_name
          } else {
            information_travellers =
              information_travellers + i.traveller_name + i.traveller_name_en
          }

          i.credential.forEach((item, index) => {
            if (item.credential != null) {
              information_travellers =
                information_travellers +
                '\n' +
                item.credential +
                ':' +
                item.credentialNum +
                '\n'
            }
          })
        })
        // 汇总
        this.information =
          information_id +
          information_date +
          information_title +
          information_time +
          num_info +
          information_other +
          addition_info +
          select_addition_info +
          information_travellers
        // 复制订单信息
        // console.log("生成订单信息");
        return this.information
      } else if (errno == '4002') {
        this.$notify({
          title: '警告',
          message: '该订单还未入库，请先入库',
          type: 'warning',
        })
      }
    },
    getVoucher(item) {
      this.$router.push({
        path: `/m_booking_voucher?booking_no=${item.booking_no}`,
      })
    },
    //
  },
}
</script>

<style>
</style>